export default __webpack_public_path__ + "static/media/03.a69ac6ca.jpg";